import React from "react";
import { Route, Redirect, Switch, useLocation } from "react-router-dom";
import { SignUp, Login, SignUpVerification, ResetPassword, Expired, AccountSignUp } from "pages";

import { Routes } from "../../constants/routes";
import { ExpiredDirectLogin } from "pages/Login/ExpiredDirectLogin";

export const PublicRoutes: React.FC = (): JSX.Element => {
  const { pathname, search } = useLocation();
  return (
    <Switch>
      <Route exact path={Routes.signUp} component={SignUp} />
      <Route exact path={Routes.signUpVerification} component={SignUpVerification} />
      <Route exact path={Routes.resetPassword} component={ResetPassword} />
      <Route exact path={Routes.login} component={Login} />
      <Route exact path={Routes.expired} component={Expired} />
      <Route exact path={Routes.expiredDirectLink} component={ExpiredDirectLogin} />
      <Route exact path={Routes.accountSignUp} component={AccountSignUp} />

      <Redirect exact from="/sign-up" to={Routes.expired} />
      <Redirect exact from="/" to={Routes.login} />

      <Redirect to={{ pathname: Routes.login, state: { enterState: { pathname, ...(search && { search }) } } }} />
    </Switch>
  );
};
